import React, { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { membershipBenefits } from '../data/mock';

const MembershipSection = ({ onContactClick }) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  return (
    <section id="membership" style={{
      backgroundColor: '#0a0a0a',
      padding: '120px 0',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px',
          alignItems: 'start',
        }} className="membership-grid">
          {/* Left: Description */}
          <div>
            <span style={{
              color: '#2d6e4a',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '12px',
              fontWeight: '700',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              display: 'block',
              marginBottom: '20px',
            }}>Membership</span>
            <h2 style={{
              color: '#ffffff',
              fontFamily: "'Climate Crisis', sans-serif",
              fontSize: 'clamp(30px, 4vw, 50px)',
              fontWeight: '400',
              letterSpacing: '0em',
              lineHeight: '1.1',
              marginBottom: '28px',
            }}>
              The Growth Circle
            </h2>
            <p style={{
              color: 'rgba(255,255,255,0.6)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '1.8',
              marginBottom: '16px',
            }}>
              A private, invite-only membership for individuals serious about elevation — as a person and beyond sports.
            </p>
            <p style={{
              color: 'rgba(255,255,255,0.6)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '1.8',
              marginBottom: '24px',
            }}>
              Limited spots. Once the founding member window closes, membership moves to <span style={{ color: '#ffffff', fontWeight: '600' }}>Cg. 199/month</span>.
            </p>
            {/* Pricing badge */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              marginBottom: '24px',
            }}>
              <div style={{
                display: 'inline-flex',
                alignItems: 'baseline',
                gap: '8px',
                padding: '10px 20px',
                background: 'rgba(200,16,46,0.08)',
                border: '1px solid rgba(200,16,46,0.3)',
                borderRadius: '12px',
              }}>
                <span style={{
                  color: '#4ade80',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '24px',
                  fontWeight: '800',
                }}>FREE</span>
                <span style={{
                  color: 'rgba(255,255,255,0.4)',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '13px',
                  fontWeight: '400',
                }}>for founding members</span>
              </div>
              <div style={{
                color: 'rgba(255,255,255,0.3)',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '14px',
                textDecoration: 'line-through',
              }}>Cg. 199/mo</div>
            </div>
            <div style={{
              padding: '24px',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '18px',
              marginBottom: '36px',
            }}>
              <p style={{
                color: 'rgba(255,255,255,0.9)',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '15px',
                fontStyle: 'italic',
                lineHeight: '1.7',
                margin: 0,
              }}>
                "This is not a motivational community.<br />
                It is a performance environment."
              </p>
            </div>
            {status === 'success' ? (
              <div style={{
                padding: '20px 24px',
                border: '1px solid rgba(27,61,42,0.5)',
                borderRadius: '14px',
                background: 'rgba(27,61,42,0.1)',
              }}>
                <p style={{
                  color: '#4ade80',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '14px',
                  fontWeight: '600',
                  margin: 0,
                }}>
                  You're in. Welcome to The Growth Circle — check your inbox.
                </p>
              </div>
            ) : showForm ? (
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  setStatus('sending');
                  try {
                    const res = await fetch('/api/membership', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(formData),
                    });
                    if (!res.ok) throw new Error();
                    setStatus('success');
                  } catch {
                    setStatus('error');
                  }
                }}
                style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
              >
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Your full name"
                  required
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '12px 16px',
                    color: '#ffffff',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease',
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                />
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="your@email.com"
                  required
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '12px 16px',
                    color: '#ffffff',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease',
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                />
                <div className="membership-phone-input">
                  <PhoneInput
                    international
                    defaultCountry="CW"
                    value={formData.phone}
                    onChange={(val) => setFormData({ ...formData, phone: val || '' })}
                    placeholder="Phone number"
                  />
                </div>
                {status === 'error' && (
                  <p style={{ color: '#ff6b7a', fontFamily: "'Figtree', sans-serif", fontSize: '12px', margin: 0 }}>
                    Could not register. Please try again.
                  </p>
                )}
                <button
                  type="submit"
                  disabled={status === 'sending'}
                  style={{
                    background: '#C8102E',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '100px',
                    padding: '14px 36px',
                    fontFamily: "'Figtree', sans-serif",
                    fontSize: '14px',
                    fontWeight: '700',
                    letterSpacing: '0.04em',
                    cursor: status === 'sending' ? 'default' : 'pointer',
                    opacity: status === 'sending' ? 0.7 : 1,
                    transition: 'background-color 0.2s ease, transform 0.2s ease',
                    alignSelf: 'flex-start',
                  }}
                  onMouseEnter={(e) => { if (status !== 'sending') { e.currentTarget.style.backgroundColor = '#a80d25'; e.currentTarget.style.transform = 'scale(1.02)'; } }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C8102E'; e.currentTarget.style.transform = 'scale(1)'; }}
                >
                  {status === 'sending' ? 'Joining...' : 'Claim Your Free Spot'}
                </button>
              </form>
            ) : (
              <button
                onClick={() => setShowForm(true)}
                style={{
                  background: '#C8102E',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '100px',
                  padding: '14px 36px',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '14px',
                  fontWeight: '700',
                  letterSpacing: '0.04em',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease, transform 0.2s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#a80d25'; e.currentTarget.style.transform = 'scale(1.02)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C8102E'; e.currentTarget.style.transform = 'scale(1)'; }}
              >
                Join Free — Limited Spots
              </button>
            )}
          </div>

          {/* Right: Benefits */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            {membershipBenefits.map((benefit, index) => (
              <div key={index} style={{
                padding: '32px',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '18px',
                transition: 'border-color 0.2s ease, background-color 0.2s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.02)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.backgroundColor = 'transparent'; }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                  <div style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    border: '1px solid rgba(255,255,255,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <span style={{
                      color: 'rgba(255,255,255,0.5)',
                      fontFamily: "'Figtree', sans-serif",
                      fontSize: '11px',
                      fontWeight: '500',
                    }}>0{index + 1}</span>
                  </div>
                  <h4 style={{
                    color: '#ffffff',
                    fontFamily: "'Climate Crisis', sans-serif",
                    fontSize: '18px',
                    fontWeight: '400',
                    letterSpacing: '0em',
                    margin: 0,
                  }}>
                    {benefit.title}
                  </h4>
                </div>
                <ul style={{ margin: 0, padding: '0 0 0 8px', listStyle: 'none' }}>
                  {benefit.items.map((item, i) => (
                    <li key={i} style={{
                      color: 'rgba(255,255,255,0.6)',
                      fontFamily: "'Figtree', sans-serif",
                      fontSize: '14px',
                      fontWeight: '400',
                      lineHeight: '1.6',
                      padding: '4px 0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}>
                      <span style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.3)', flexShrink: 0 }} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .membership-grid {
            grid-template-columns: 1fr !important;
            gap: 48px !important;
          }
        }
        .membership-phone-input .PhoneInput {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 12px;
          padding: 8px 16px;
          transition: border-color 0.2s ease;
        }
        .membership-phone-input .PhoneInput:focus-within {
          border-color: rgba(255,255,255,0.4);
        }
        .membership-phone-input .PhoneInputInput {
          background: transparent;
          border: none;
          color: #ffffff;
          font-family: 'Figtree', sans-serif;
          font-size: 14px;
          outline: none;
          padding: 4px 0;
        }
        .membership-phone-input .PhoneInputInput::placeholder {
          color: rgba(255,255,255,0.2);
        }
        .membership-phone-input .PhoneInputCountry {
          margin-right: 10px;
        }
        .membership-phone-input .PhoneInputCountrySelect {
          background: transparent;
          color: #ffffff;
          border: none;
          font-family: 'Figtree', sans-serif;
          font-size: 14px;
        }
        .membership-phone-input .PhoneInputCountrySelect option {
          background: #1a1a1a;
          color: #ffffff;
        }
        .membership-phone-input .PhoneInputCountryIcon--border {
          box-shadow: none;
          border: none;
        }
      `}</style>
    </section>
  );
};

export default MembershipSection;
